import { render } from "./Tamanos.vue?vue&type=template&id=4a3a0ef1&scoped=true"
import script from "./Tamanos.vue?vue&type=script&lang=js"
export * from "./Tamanos.vue?vue&type=script&lang=js"

import "./Tamanos.vue?vue&type=style&index=0&id=4a3a0ef1&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3a0ef1"]])

export default __exports__